import { connect } from 'react-redux';
import { getTexts, Loader } from '@twnel/web-components';

import { resetChatbots } from 'data/actions';
import { selectedCompany } from 'data/selectors';
import { resetVisualbuilder } from './VisualBuilder/connect/actions';
import SplashLoading from './General/SplashLoading';
import AppView from './AppView';

const modules = [
  {
    moduleName: 'Home',
    Fallback: SplashLoading,
    Component: Loader({}, () => import('./Builder')),
    alt: 'Your Bots',
    icon: 'fas fa-stream',
    path: '/',
    // path para navegación del sidebar; routePath es el path de la ruta v6.
    // Splat porque Builder renderiza <Routes> anidadas (react-router v6 exige
    // que el padre termine en /* para que los hijos descendientes matcheen).
    routePath: '/*',
    exact: true,
  },
  {
    moduleName: 'Spec Builder',
    Fallback: SplashLoading,
    Component: Loader({}, () => import('./SpecBuilder')),
    path: '/specbuilder/:id',
    exact: true,
  },
  {
    moduleName: 'Visual Builder',
    Fallback: SplashLoading,
    Component: Loader({}, () => import('./VisualBuilder')),
    path: '/visualbuilder/:id',
    exact: true,
  },
];

const mapStateToProps = (state) => {
  const company = selectedCompany(state);
  return {
    companyId: company ? company.id : null,
    getTexts: getTexts(state),
    modules,
  };
};

const mapDispatchToProps = (dispatch) => ({
  resetStore: () => {
    dispatch(resetChatbots());
    dispatch(resetVisualbuilder());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AppView);
